import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CatalogoDetalleBean } from 'src/app/_beans/CatalogoDetalleBean';
import { MetaBean } from 'src/app/_beans/MetaBean';
import { ObjetivoBean } from 'src/app/_beans/ObjetivoBean';
import { MetaAtributoAdicionalDTO } from 'src/app/_dtos/MetaAtributoAdicionalDTO';
import * as moment from 'moment';
import { AddResponsableMetaComponent } from '../add-responsable-meta/add-responsable-meta.component';
import { ResponsableMetaBean } from 'src/app/_beans/ResponsableMetaBean';
@Component({
  selector: 'app-meta-dialog',
  templateUrl: './meta-dialog.component.html',
  styleUrls: ['./meta-dialog.component.scss']
})
export class MetaDialogComponent implements OnInit {
  metaSelect: MetaBean;
  titulo: string = "Agregar";
  checked: boolean;
  frecuenciaControlList: CatalogoDetalleBean[] = [];
  catalogoProcedimientoList: CatalogoDetalleBean[] = [];
  catalogoIndicadorList: CatalogoDetalleBean[] = [];
  catalogoNormativaList: CatalogoDetalleBean[] = [];
  valorFormulaCalculoSeleccionado: string;
  atributosAdicionalesSelectMap = new Map<number, any>();
  atributosAdicionalesSeleccionados: MetaAtributoAdicionalDTO[] = [];
  idPlan: number;
  objetivosMultiLevelList: any[] = [];
  responsableMetaList: ResponsableMetaBean[] = [];
  responsableMetaDeleteList: ResponsableMetaBean[] = [];
  esIndicadorPorObjetivo= false;
  constructor(
    private cdr: ChangeDetectorRef,
    public sharedService: SharedService,
    private restProvider: RestProviderService,
    public constantes: ConstantesService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<MetaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MetaBean,
  ) { }

  ngOnInit(): void {
    this.idPlan = this.data.idPlan;
    this.obtenerTipoIndicadorList();
    this.obtenerProcedimientosList();
    this.obtenerNormativaList();
    this.obtenerFrecuenciaControlList();
    this.cdr.markForCheck();
    if (this.data.id) {
      this.titulo = "Editar";
        let params = {
          data: {
            id: this.data.id
          }
        }
        this.restProvider.executeHttpMethod("/mc/bpi", params).subscribe((result: any) => {
          this.metaSelect = result.data;
          this.responsableMetaList=this.metaSelect.responsableMetaList;
          this.metaSelect.responsableMetaDeleteList=[];
          this.metaSelect.fechaInicio = this.sharedService.addTimeOffSet(this.metaSelect.fechaInicio);
          this.metaSelect.fechaFin = this.sharedService.addTimeOffSet(this.metaSelect.fechaFin);
          this.metaSelect.idPlan = this.data.idPlan;
          this.metaSelect.nombreDinamico = this.data.nombreDinamico;
        }, error => {
          console.error(error);
        });
    } else {
      if (this.data.abrirDesdeMenu) {
        this.obtenerTodosLosObjetivosPorIDConfiguracionPlan(this.sharedService.planSession.listaConfiguracionPlan[0].id);
        this.cdr.markForCheck();
      }
      this.metaSelect = new MetaBean();
      this.metaSelect.responsableMetaList=[];
      this.metaSelect.responsableMetaDeleteList=[];
      this.metaSelect.objetivo = new ObjetivoBean();
      this.metaSelect.publicado = this.constantes.NO_ESTA_PUBLICADO;
      if (this.data.objetivo)
        this.metaSelect.objetivo = this.data.objetivo;
      this.metaSelect.idPlan = this.data.idPlan;
      this.metaSelect.nombreDinamico = this.data.nombreDinamico;
    }
  }

  public obtenerTodosLosObjetivosPorIDConfiguracionPlan(idConfPlan: number) {
    let params = {
      data: {
        configuracionPlan: {
          id: idConfPlan
        }
      }
    }
    this.sharedService.planSession.listaConfiguracionPlan.forEach(conf => {
      if (conf.nivel < this.data.configuracionPlan.nivel){
          conf.objetivos = [];
          this.objetivosMultiLevelList.push(conf);
      }

    })
    return new Promise((resolve, reject) => {
      this.restProvider.executeHttpMethod("/oc/lpicp", params).subscribe((result: any) => {
        if (this.data.abrirDesdeMenu) {
          this.objetivosMultiLevelList[0].objetivos = [];
          this.objetivosMultiLevelList[0].objetivos = result.datalist;
        } else
          this.sharedService.sendObjectList.next(result.datalist);
        resolve("success");
      });
    });
  }

  public obtenerProcedimientosList() {
    let params = {
      data: {
        id: this.constantes.ID_CATALOGO_TIPO_PROCEDIMIENTO_ALMACENADO
      }
    }
    this.restProvider.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
      this.catalogoProcedimientoList = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public obtenerNormativaList() {
    let params = {
      data: {
        id: this.constantes.ID_CATALOGO_NORMATIVA
      }
    }
    this.restProvider.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
      this.catalogoNormativaList = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public obtenerTipoIndicadorList() {
    let params = {
      data: {
        id: this.constantes.ID_CATALOGO_TIPO_INDICADOR
      }
    }
    this.restProvider.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
      this.catalogoIndicadorList = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public obtenerFrecuenciaControlList() {
    let params = {
      data: {
        id: this.constantes.ID_CATALOGO_FRECUENCIAS_CONTROL
      }
    }
    this.restProvider.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
      this.frecuenciaControlList = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public guardarMeta() {
    let fechaDeInicio: any;
    let fechaDeFin: any;
    if(this.metaSelect.fechaInicio instanceof moment) {
      fechaDeInicio = this.metaSelect.fechaInicio;
      this.metaSelect.fechaInicio = fechaDeInicio.toDate();
    }
    if(this.metaSelect.fechaFin instanceof moment) {
      fechaDeFin = this.metaSelect.fechaFin;
      this.metaSelect.fechaFin = fechaDeFin.toDate();
    }
    if (this.metaSelect.fechaInicio.getTime() >= this.metaSelect.fechaFin.getTime()) {
      this.sharedService.showMessageWarn("La fecha final debe ser posterior a la fecha inicial");
      return;
    }
    if (this.metaSelect.lineaBase < 0) {
      this.sharedService.showMessageWarn("La linea base debe ser mayor a cero");
      return;
    }
    this.metaSelect.responsableMetaList=this.responsableMetaList;
    this.metaSelect.responsableMetaDeleteList=this.responsableMetaDeleteList;
    let params = {
      data: this.metaSelect
    }
    this.restProvider.executeHttpMethod("/mc/g", params).subscribe((result: any) => {
      this.metaSelect=result.data;
      this.metaSelect.esIndicadorPorObjetivo=this.esIndicadorPorObjetivo;
      this.cerrar(this.metaSelect);
    }, error => {
      console.error(error);
    });
  }

  public deleteElement(responsableMeta : ResponsableMetaBean){
    let index = this.responsableMetaList.findIndex(respMeta => respMeta.unidadOrganica.id === responsableMeta.unidadOrganica.id);
    if (index > -1) {
      this.responsableMetaList.splice(index, 1);
      if(responsableMeta.id){
        this.responsableMetaDeleteList.push(responsableMeta);
      }
   }
  }

  public abrirAddResponsable() {
    let metaDialogHref = this.dialog.open(AddResponsableMetaComponent, {
      width: "550px",
      disableClose: true
    });
    metaDialogHref.afterClosed().subscribe(data => {
      if (data) {
        let index = this.responsableMetaList.findIndex(respMeta => respMeta.unidadOrganica.id === data.unidadOrganica.id);
        if (index > -1) {
          this.sharedService.showMessageWarn("El elemento agregado ya existe en la lista");
        }else{
          data.unidadOrganica.nombre=data.entidad.abreviatura+(data.despacho.abreviatura?(" / "+data.despacho.abreviatura):"")+(data.direccionGeneral.abreviatura?(" / "+data.direccionGeneral.abreviatura):"")+(data.direccionLinea.abreviatura?(" / "+data.direccionLinea.abreviatura):"")+(data.area.abreviatura?(" / "+data.area.abreviatura):"")
          this.responsableMetaList.push(data);
        }
      }
    })
  }

  public cerrar(meta?: MetaBean) {
    meta ? this.dialogRef.close(meta) : this.dialogRef.close();
  }

  public validarCampos() {
    if (this.metaSelect.fuente && this.metaSelect.descripcion && this.metaSelect.fechaFin && this.metaSelect.fechaInicio && this.metaSelect.idFrecControl && this.metaSelect.idNormativa /*&& this.metaSelect.idProcedimiento (por el momento)*/&& this.metaSelect.objetivo && this.metaSelect.objetivo.id && this.metaSelect.formaMedicion /*&& this.metaSelect.entidad*/) {
        return false;
    } else {
      return true;
    }
  }

  public seleccionarObjetivo(event: any, posicion: number) {
    if (event.value) {
      this.limpiarObjetivosList(posicion + 1);
      if (this.objetivosMultiLevelList.length - 1 != posicion){
        this.obtenerTodosLosObjetivosPorIDObjetivoPadre(event.value.id, event.value.configuracionPlan.nivel);
        if(posicion==0){
          this.metaSelect.objetivo = new ObjetivoBean();
          this.metaSelect.objetivo.id = event.value.id;
          this.esIndicadorPorObjetivo=true;
        }else{
          this.metaSelect.objetivo = undefined;
          this.esIndicadorPorObjetivo=false;
        }
      }else {
        this.metaSelect.objetivo = new ObjetivoBean();
        this.metaSelect.objetivo.id = event.value.id;
        this.esIndicadorPorObjetivo=false;
      }
    }
  }

  public limpiarObjetivosList(posicion: number) {
    for (let index = posicion; index < this.objetivosMultiLevelList.length; index++)
      this.objetivosMultiLevelList[index].objetivos = [];
  }

  public obtenerTodosLosObjetivosPorIDObjetivoPadre(id: number, nivel?: number) {
    let params = {
      data: {
        objetivoPadre: {
          id: id
        }
      }
    }
    this.restProvider.executeHttpMethod("/oc/lpiop", params).subscribe((result: any) => {
      if (this.data.abrirDesdeMenu) {
        this.objetivosMultiLevelList[nivel].objetivos = result.datalist;
      } else {
        this.sharedService.sendObjectList.next(result.datalist);
        this.cerrar();
      }
    }, error => {
      console.error(error);
    });
  }

}
